import { useEffect, useState } from 'react';
import { removeServer } from 'src/api/userInfo';
import { Error_Icon, MsSql_Icon, Offline_Icon, Warning_Icon } from 'src/components/device_management/icons';
import Online_Icon from 'src/components/widgets/widget_layouts/icons/DeviceListControl/Online_Icon';
import { cn } from 'src/lib/utils';
import { useSWRConfig } from 'swr';
import { DeleteConfirmationAlert } from '../../ui/alert-dialog/delete-server-confirmation';
import SetupServer from './SetupServer';
import LoadingContainer from 'src/components/ui/loading/loading-container';
import { useTranslation } from 'react-i18next'

//deviceDetails
const ServerDetails = ({ deviceList, serverList, serverConfirmation, plantId , isLoadingServerList, isErrorServerList }) => {
    const { mutate } = useSWRConfig()
    const disabledAddBtn = (serverList?.length !== 0 || serverList?.length < 6) ? false : true
    const [servers, setServers] = useState(serverList)
    const { t } = useTranslation("settings");
    const [showSetup, setShowSetup] = useState(false)
    const [isEditServer, setIsEditServer] = useState(false)
    const [serverDetails, setServerDetails] = useState({ status: false, info: undefined })
    const deviceTotal = deviceList?.devices?.length

    useEffect(() => {
        setServers(serverList)
    }, [serverList])

    const removeServers = async (server) => {
        try {
            const remove = removeServer(plantId, server)
            mutate(`/api/plant/${plantId}/server/`)
            //   window.location.reload(false)
        } catch (error) {
            alert(error)
        }
    }

    const closeAddServer = async () => {
        // await mutate(`${API_URL}/plant/${plantId}/server`, true)
        mutate(`/api/plant/${plantId}/server/`)
        // if(reload){
        //     window.location.reload(false)
        // }
        setShowSetup(false)
        setServers(serverList)
        setIsEditServer(false)
    }

    const openEditServer = (server) => {
        setServerDetails(server)
        setShowSetup(true)
        setIsEditServer(true)
    }
    const openAddServer = () => {
        setShowSetup(true)
    }

    const calculateSummaryAmount = (statuses) => {
        // summary of the status into 4 categories
        const statusAmounts = statuses.reduce((output, currentValue) => ({[currentValue.status]: currentValue.amt || 0, ...output}),{})
        const summary = { 
            online: statusAmounts.online + statusAmounts.charging + statusAmounts.driving + statusAmounts.parking + statusAmounts.finishing + statusAmounts.available + statusAmounts.preparing + statusAmounts.active + statusAmounts.standby, 
            offline: statusAmounts.offline, 
            warning: statusAmounts.warning + statusAmounts['battery low'] + statusAmounts.maintenance, 
            error: statusAmounts.error + statusAmounts.accident + statusAmounts.fail
        };

        //get percentage
        summary.online_percentage = (summary.online / statuses?.length) * 100 || 0;
        summary.offline_percentage = (summary.offline / statuses?.length) * 100 || 0;
        summary.warning_percentage = (summary.warning / statuses?.length) * 100 || 0;
        summary.error_percentage = (summary.error / statuses?.length) * 100 || 0;

        return {statusSummary:summary, statusAmounts}
    };
    const {statusSummary, statusAmounts} = calculateSummaryAmount(deviceList?.status_overview || []);

    const statusIcons = {
        online: <Online_Icon />,
        offline: <Offline_Icon />,
        warning: <Warning_Icon />,
        error: <Error_Icon />
    }

    return ( 
       <LoadingContainer
        isLoading={isLoadingServerList}
        hasData={serverList?.length > 0}
        isError={isErrorServerList}
        loadingText={`${t('device_management.loading.loading_server')}...`}
        errorText={`${t('device_management.loading.error_server')}`}
        noDataText={`${t('device_management.loading.no_server')}`}
        >
            <section className="h-auto gap-4 p-4 mx-4 bg-white rounded-md shadow-xl">
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6">
                    <div className="grid md:col-span-3 lg:col-start-1 lg:col-end-6">
                        <div className="flex items-center gap-8">
                            <h1 className="text-xl font-bold">{t('device_management.server')}</h1>
                            <button className="w-6 h-6 text-sm rounded-full shadow-xl bg-vekin-green-50">
                                <i className="ri-arrow-up-s-line"></i>
                            </button>
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button disabled={disabledAddBtn} onClick={() => openAddServer()}
                            className={`flex items-center gap-1 p-4 text-sm font-semibold text-white rounded-lg ${disabledAddBtn ? 'bg-gray-300' : 'bg-vekin'
                                }`}
                        >
                            <i className="ri-add-line"></i>{t('device_management.add_server')}
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5">
                    {servers?.length > 0 && servers?.map((server) => (

                        <div key={server?.name} className="p-4 m-4 bg-white h-[320px] rounded-md shadow-lg" >
                            <div className='flex items-center justify-between'>
                                <MsSql_Icon />
                                <DeleteConfirmationAlert
                                    category={"server"}
                                    item={server}
                                    onContinue={() => removeServers(server)}
                                />
                            </div>

                            <div onClick={() => openEditServer(server)}>
                                <div className="flex flex-col gap-2">
                                    <h1 className="pt-2 text-sm font-bold">{server?.name}</h1>
                                    <div className="flex items-end gap-2">
                                        <p className="text-lg font-semibold text-vekin">{deviceTotal}</p>
                                        <p className="text-sm font-medium">{t('device_management.device')}</p>
                                    </div>
                                    <div class="relative pt-[2px] mx-[1px] w-full">
                                        <div class="overflow-hidden h-2 mb-1 text-xs flex rounded-[8px] bg-vekin-greengray flex-row w-full">
                                            <div className="h-full bg-vekin" style={{ width: `${statusSummary?.online_percentage}%` }} ></div>
                                            <div className="h-full bg-vekin-gray10" style={{ width: `${statusSummary?.offline_percentage}%` }}></div>
                                            <div className="h-full bg-vekin-redA" style={{ width: `${statusSummary?.error_percentage}%` }}></div>
                                            <div className="h-full bg-vekin-yellow10" style={{ width: `${statusSummary?.warning_percentage}%` }}></div>
                                            {/* test */}
                                        </div>
                                    </div>
                                </div>

                                <div className='relative mt-2 space-y-4'>

                                   

                                    {deviceList?.status_overview?.map((server_status) => (
                                        <div
                                            key={server_status?.status}
                                            className="flex items-center justify-between cursor-pointer"
                                        >
                                            <div className="flex items-center justify-center gap-1.5 order group">
                                                {statusIcons[server_status?.status]}
                                                {/* Status */}
                                                <span className={cn('text-sm font-normal')}>
                                                    {['online', 'offline', 'warning', 'error'].includes(server_status.status) ? server_status.status : null}
                                                </span>
                                               
                                               {server_status.status !='offline' &&<div className='absolute hidden w-auto p-2 text-xs bg-white border rounded-md shadow group-hover:block left-20'>
                                                    {server_status.status == 'online' && <>
                                                        <p> <span className='font-semibold'>{t('device_management.status.online')}:</span> {statusAmounts?.online} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.charging')}:</span> {statusAmounts?.charging} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.driving')}:</span> {statusAmounts?.driving} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.parking')}:</span> {statusAmounts?.parking} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.finishing')}:</span> {statusAmounts?.finishing} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.available')}:</span> {statusAmounts?.available} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.preparing')}:</span> {statusAmounts?.preparing} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.active')}:</span> {statusAmounts?.active} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.standard')}:</span> {statusAmounts?.standby} </p>
                                                    </>}

                                                    {server_status.status == 'error' && <>
                                                        <p> <span className='font-semibold'>{t('device_management.status.accident')}:</span> {statusAmounts?.accident} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.fail')}:</span> {statusAmounts?.fail} </p>
                                                    </>}

                                                    {server_status.status == 'warning' && <>
                                                        <p> <span className='font-semibold'>{t('device_management.status.battery_low')}:</span> {statusAmounts?.['battery low']} </p>
                                                        <p> <span className='font-semibold'>{t('device_management.status.maintenance')}:</span> {statusAmounts?.maintenance} </p>
                                                    </>}  
                                                </div> }
                                            </div>

                                            {/* count status */}
                                                <p className={cn('font-bold text-sm', {
                                                    'text-vekin': server_status.status === 'online',
                                                    'text-tertiary': server_status.status === 'offline',
                                                    'text-orange': server_status.status === 'warning',
                                                    'text-red-500': server_status.status === 'error'
                                                })} >{statusSummary[server_status?.status]}</p>

                                            
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </section>

            {showSetup && <SetupServer
                isEditServer={isEditServer}
                onClose={closeAddServer}
                showSetup={showSetup}
                server={serverDetails}
                plantId={plantId}
            />
            }
            {/* <CreateNewServer
          closeAddServer={closeAddServer}
          isServer={showSetup}
          isEditServer={isEditServer}
        /> */}
        </LoadingContainer>
        
        
    );
}

export default ServerDetails;
